/* eslint-disable react/no-array-index-key */
/* eslint-disable no-shadow */
import React, { Fragment } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/20/solid';
import PropTypes from 'prop-types';
import {
    setTypeFunc,
   } from '../../../assets/scripts/script';

   function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }
  
   export function ListExtra({
    title, arr, val, func1, func2,
}) {
    return (
      <>
        <span className="block mb-2 text-sm">
          {title}
        </span>
        <Listbox
          value={val}
          onChange={(e) => setTypeFunc(e, func1, func2)}
        >
        {({ open }) => (
        <>
          <Listbox.Label className="sr-only">Change published status</Listbox.Label>
          <div className="relative">
            <div className="inline-flex divide-x divide-gray-200 rounded-md shadow-sm">
              <div className="inline-flex items-center gap-x-1.5 rounded-l-md bg-red-700 px-3 py-2 text-white shadow-sm">
                <p className="text-sm capitalize font-semibold">{val.title}</p>
              </div>
              <Listbox.Button className="inline-flex items-center rounded-l-none rounded-r-md bg-red-700 p-2 hover:bg-red-700 focus:outline-none">
                <span className="sr-only">Change published status</span>
                <ChevronDownIcon className="h-5 w-5 text-white" aria-hidden="true" />
              </Listbox.Button>
            </div>

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute overflow-hidden right-0 z-10 mt-2 w-72 origin-top-right divide-y divide-red-700 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                {arr.map((option) => (
                  <Listbox.Option
                    key={option.title}
                    className={({ active }) =>
                      classNames(
                        active ? 'bg-red-700 text-white' : 'text-gray-900',
                        'cursor-pointer hover:bg-red-700 capitalize hover:text-white select-none p-4 text-sm'
                      )
                    }
                    value={option}
                  >
                    {({ selected, active }) => (
                      <div className="flex flex-col">
                        <div className="flex justify-between text-sm">
                          <p className={`${selected ? 'font-semibold' : 'font-normal'} capitalize`}>{option.title}</p>
                          {selected ? (
                            <span className=''>
                              <CheckIcon className="h-5 w-5" aria-hidden="true" />
                            </span>
                          ) : null}
                        </div>
                        <p className='mt-2'>
                          {option.description}
                        </p>
                      </div>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </>
      )}
        </Listbox>
      </>
    );
}

ListExtra.propTypes = {
    title: PropTypes.string.isRequired,
    arr: PropTypes.arrayOf(PropTypes.shape).isRequired,
    val: PropTypes.objectOf(PropTypes.shape).isRequired,
    func1: PropTypes.func.isRequired,
    func2: PropTypes.func.isRequired,
  };
